export const redirect = (location: string) => {
  window.location.href = location;
};

export type LinkTarget = '_blank' | '_self' | '_parent' | '_top';
